module.exports = __webpack_public_path__ + "static/img/megandanaher_circle150.5a72895.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experts/megandanaher_circle150.png
// module id = 0U+D
// module chunks = 0